import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { SiteProvider } from "./context/SiteContext";
import { CurrencyProvider } from "./context/CurrencyContext";
import { Toaster } from "./components/ui/sonner";
import PublicLayout from "./components/PublicLayout";
import AuthCallback from "./components/AuthCallback";
import ProtectedAdmin from "./components/ProtectedAdmin";
import Home from "./pages/Home";
import Pricing from "./pages/Pricing";
import RushHour from "./pages/RushHour";
import Standard from "./pages/Standard";
import CaseStudies from "./pages/CaseStudies";
import LiveBuild from "./pages/LiveBuild";
import About from "./pages/About";
import Contact from "./pages/Contact";
import GetEstimate from "./pages/GetEstimate";
import BookRushHour from "./pages/BookRushHour";
import Checkout from "./pages/Checkout";
import Invoice from "./pages/Invoice";
import Legal from "./pages/Legal";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import RefundPolicy from "./pages/RefundPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import Leads from "./pages/admin/Leads";
import Bookings from "./pages/admin/Bookings";
import Payments from "./pages/admin/Payments";
import Settings from "./pages/admin/Settings";
import AdminCaseStudies from "./pages/admin/AdminCaseStudies";

function AppRouter() {
  const location = useLocation();
  // Emergent OAuth returns session_id in the URL fragment — process before any route guard runs.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/standard" element={<Standard />} />
        <Route path="/rush-hour" element={<RushHour />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/case-studies" element={<CaseStudies />} />
        <Route path="/live-build" element={<LiveBuild />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/get-estimate" element={<GetEstimate />} />
        <Route path="/book-rush-hour" element={<BookRushHour />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/invoice/:paymentId" element={<Invoice />} />
        <Route path="/legal" element={<Legal />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsConditions />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
      </Route>
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route
        path="/admin"
        element={
          <ProtectedAdmin>
            <AdminLayout />
          </ProtectedAdmin>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="leads" element={<Leads />} />
        <Route path="bookings" element={<Bookings />} />
        <Route path="payments" element={<Payments />} />
        <Route path="case-studies" element={<AdminCaseStudies />} />
        <Route path="settings" element={<Settings />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <SiteProvider>
      <CurrencyProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="bottom-right" richColors />
        </BrowserRouter>
      </CurrencyProvider>
    </SiteProvider>
  );
}

export default App;
